import { z } from "zod";

export const openCartonsCountByStatusSchema = z.object({
	imported: z.number(),
	staged: z.number(),
	selected: z.number(),
});
export type OpenCartonsCountByStatus = z.infer<typeof openCartonsCountByStatusSchema>;

export const cartonCountByProductionGroupSchema = z.object({
	productionGroupId: z.string(),
	open: z.number(),
	failed: z.number(),
});
export type CartonCountByProductionGroup = z.infer<typeof cartonCountByProductionGroupSchema>;

export const countByPickZoneSchema = z.object({
	pickZoneAlias: z.union([z.string(), z.null()]),
	count: z.number(),
});
export type CountByPickZone = z.infer<typeof countByPickZoneSchema>;

export const countByCartonPropertyGroupSchema = z.object({
	cpgAlias: z.union([z.string(), z.null()]),
	count: z.number(),
});
export type CountByCartonPropertyGroup = z.infer<typeof countByCartonPropertyGroupSchema>;

export const countByClassificationSchema = z.object({
	classificationAlias: z.union([z.string(), z.null()]),
	count: z.number(),
});
export type CountByClassification = z.infer<typeof countByClassificationSchema>;

export const limitedProducibilityDataSchema = z.object({
	failed: z.number(),
	blocked: z.number(),
	nonOptimal: z.number(),
});
export type LimitedProducibilityData = z.infer<typeof limitedProducibilityDataSchema>;

export const estimatedCorrugateUsageDataSchema = z.record(z.string(), z.number());
export type EstimatedCorrugateUsageData = z.infer<typeof estimatedCorrugateUsageDataSchema>;

export const machineTrackOutOfCorrugateSchema = z.object({
	trackNumber: z.number(),
	corrugateAlias: z.string().nullable(),
	corrugateLastLoadedUtc: z.string(),
	emptyDuration: z.string(),
});
export type MachineTrackOutOfCorrugate = z.infer<typeof machineTrackOutOfCorrugateSchema>;

export const machineOutOfCorrugateSchema = z.object({
	alias: z.string(),
	tracks: z.array(machineTrackOutOfCorrugateSchema),
});
export type MachineOutOfCorrugate = z.infer<typeof machineOutOfCorrugateSchema>;

export const machinesOutOfCorrugateDataSchema = z.object({
	tenantId: z.string(),
	machines: z.array(machineOutOfCorrugateSchema),
});
export type MachinesOutOfCorrugateData = z.infer<typeof machinesOutOfCorrugateDataSchema>;
